import { render, staticRenderFns } from "./GraficoFaturamentoAcumulado.vue?vue&type=template&id=12ff5b89&scoped=true"
import script from "./GraficoFaturamentoAcumulado.vue?vue&type=script&lang=ts"
export * from "./GraficoFaturamentoAcumulado.vue?vue&type=script&lang=ts"
import style0 from "./GraficoFaturamentoAcumulado.vue?vue&type=style&index=0&id=12ff5b89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ff5b89",
  null
  
)

export default component.exports